// extracted by mini-css-extract-plugin
export var csatScore = "_i9-5";
export var header = "_i9-1";
export var panelWrapper = "_i9-2";
export var postPreview = "_i9-3";
export var rightContent = "_i9-0";
export var wrappingText = "_i9-4";